<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.objectStatus"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Objekto būsena"
                  v-model="mainData['status-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Objekto ID"
                  v-model="mainData['code-search-custom']"
                  hide-details
                  :maxlength="10"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.objectType"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Objekto tipas"
                  v-model="mainData['kind-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Notarinio reg. Nr."
                  v-model="mainData['notarial_no-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Įregistravimo data nuo"
                  v-model="mainData['registration_date-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Įregistravimo data iki"
                  v-model="mainData['registration_date-search-to']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Išregistravimo data nuo"
                  v-model="mainData['deregistration_date-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Išregistravimo data iki"
                  v-model="mainData['deregistration_date-search-to']"
                />
              </v-col>
              <v-col class="pt-1" cols="12" md="6" lg="3">
                <el-text-field
                  label="Asmens vardas"
                  v-model="mainData['fiz_name-search-custom']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pt-1" cols="12" md="6" lg="3">
                <el-text-field
                  label="Asmens pavardė"
                  v-model="mainData['fiz_lastname-search-custom']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pt-1" cols="12" md="6" lg="3">
                <el-text-field
                  label="Asmens kodas"
                  v-model="mainData['fiz_code-search-custom']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col class="pt-1" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Gimimo data"
                  v-model="mainData['fiz_birthdate-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Juridinio asmens kodas"
                  v-model="mainData['jur_code-search-custom']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Juridinio asmens pavadinimas"
                  v-model="mainData['jur_name-search-custom']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="mandates" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'ObjectDataChangeSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        } 
      })
    },
  },
}
</script>
